import { getBgmBehavior } from '@ps/bridge/qc/node/game-play'
import { getMainConfigScript } from '@ps/bridge/qc/node/ui-root'
import _ from 'lodash'

const getInitConfig = () => {
  return {
    sourceAudioDuration: 0, // 原音效时长
    sourceAudioUrl: '', // 原音效url
    audioUrl: '', // 当前音效 URL
    clipStartTime: 0, // 上一次裁剪起始时间，单位毫秒
    clipEndTime: 0, // 上一次裁剪结束时间，单位毫秒
    volume: 100,
    autoPlay: true,
    loopNumber: 1, // [<= 0]:循环 [>0]:次数播放
    loop: true,
    size: 0,
  }
}

const keyMap = {
  sourceAudioDuration: 'bgmSourceAudioDuration', // 原音效时长
  sourceAudioUrl: 'bgmSourceAudioUrl', // 原音效url
  audioUrl: 'bgmAudioUrl', // 当前音效 URL
  clipStartTime: 'bgmClipStartTime', // 上一次裁剪起始时间，单位毫秒
  clipEndTime: 'bgmClipEndTime', // 上一次裁剪结束时间，单位毫秒
  volume: 'bgmVolume', // 音量
  autoPlay: 'bgmAutoPlay', // 自动播放
  loopNumber: 'bgmLoopNumber', // [<= 0]:循环 [>0]:次数播放
  loop: 'bgmLoop', // 循环播放
  size: 'bgmSize', // 文件大小
}

export default {
  namespaced: true,
  state: {
    config: getInitConfig(),
    timestamp: 0,
  },
  mutations: {
    setBgmBehConfig(state, config) {
      const bgBeh = getBgmBehavior()
      if (!bgBeh) return
      const data = Object.keys(config).reduce((memo, cur) => {
        memo[keyMap[cur]] = config[cur]
        return memo
      }, {})
      bgBeh.setBgmConfig(data)

      const mainConfigScript = getMainConfigScript()
      // 从 pt 转到 ps 的非标准包的背景音乐自动播放配置是存储带 mainConfig 脚本中的
      if (mainConfigScript && !_.isUndefined(config.autoPlay)) {
        mainConfigScript.autoPlayBgm = config.autoPlay
      }
    },
    setBgmConfig(state, newConfig) {
      const config = state.config
      state.config = {
        ...config,
        ...newConfig,
      }
      state.timestamp = Number(new Date())
      // if (isIvPage()) {
      // todo 背景音乐预加载
      //   playPsBgm()
      //   pausePsBgm()
      // }
    },

    // 获取当前bgm的 AudioBeh 数据，并且赋值到 state 里
    setCurrentBgmConfig(state) {
      const bgmBeh = getBgmBehavior()
      const assignKey = Object.keys(getInitConfig())
      assignKey.forEach((key) => {
        state.config[key] = bgmBeh[keyMap[key]]
      })
    },
    updateTimestamp(state, value) {
      state.timestamp = value
    },
  },
  actions: {
    removeBgm({ commit }) {
      const config = getInitConfig()
      commit('setBgmConfig', config)
      commit('setBgmBehConfig', config)
    },
  },
}
